export default __webpack_public_path__ + "static/media/stomach3.b75c7da8.jpg";